import { twMerge } from 'tailwind-merge';
import {
  default as MuiTableCell,
  type TableCellProps as MuiTableCellProps,
} from '@mui/material/TableCell';
import { classes } from './utils';

export interface TableCellProps extends MuiTableCellProps {
  className?: string;
}

export default function TableCell({
  className = '',
  ...props
}: TableCellProps) {
  return (
    <MuiTableCell className={twMerge(classes.cell, className)} {...props} />
  );
}
